module.exports = __webpack_public_path__ + "img/472.b661d15a.jpg";